export enum EnumLogoutReason{
    General
}